type PdfConvertingBadgeProps = {
  label?: string;
  hint?: string;
};

export default function PdfConvertingBadge({
  label = "변환 중...",
  hint = "최대 2분 소요",
}: PdfConvertingBadgeProps) {
  return (
    <div className="flex flex-col items-center justify-center h-40 sm:h-44 bg-gradient-to-br from-indigo-50 to-purple-50">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-indigo-400 border-t-transparent mb-2"></div>
      <p className="text-xs text-indigo-500 font-medium">{label}</p>
      <p className="text-xs text-gray-400 mt-1">{hint}</p>
    </div>
  );
}
